/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Row, Column } from 'components/UI/ColumnAndRow';

export const SingleColumnLayout = ({ children, ...props }) => {
  return (
    <Row flexDirection="column" {...props}>
      {children}
    </Row>
  );
};

export const TwoColumnLayout = ({ children, ...props }) => {
  return (
    <Row flexDirection="row" {...props}>
      {children}
    </Row>
  );
};
